import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ExtMaterialAttrManage ( props ) {

    return <BasicCrudScreenType id="ExtMaterialAttrManage" noExcel table="ExtMaterialAttr" view="ExtMaterialAttr"   />

}

export default ExtMaterialAttrManage;